import { Outlet, useLocation } from '@tanstack/react-router';
import { useEffect } from 'react';

import { track } from '@core/analytics/track.js';

/**
 * Root layout — fires a `page_viewed` event on every navigation (initial
 * mount and every subsequent `location.pathname` change), covering public
 * pages (`/login`, `/cookies`) and authenticated routes alike.
 *
 * Why a manual event when PostHog's `capture_pageview: true` already auto-
 * captures `$pageview`: the SDK's auto-pageview only fires post-init, and
 * the PostHog tag's machine inits only after the user grants `measurement`
 * consent. Pageviews that fire BEFORE the grant would otherwise be lost.
 * Routing the call through `track()` lets the tag's pre-grant queue catch
 * them; the machine flushes the queue on `idle → activeNoId`. Post-grant
 * this duplicates `$pageview` — accept the noise; query against whichever
 * name fits your need.
 *
 * Only `location.pathname` is sent — no querystring, no hash — to keep
 * sensitive search params (UTM strings, error tokens, etc.) out of the
 * analytics surface.
 */
export function RootLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    track('page_viewed', { path: pathname });
  }, [pathname]);
  return <Outlet />;
}
